/* istanbul ignore file */
import { array as codecArray, boolean as codecBoolean, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { FixtureLike } from './FixtureLike';
const JsonPatchAutoTestParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['setupScript', /* #__PURE__ */ codecOptional(codecString), 'setup_script'],
    ['runSetupScript', /* #__PURE__ */ codecOptional(codecString), 'run_setup_script'],
    [
        'hasNewFixtures',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'has_new_fixtures',
    ],
    ['enableCaching', /* #__PURE__ */ codecOptional(codecBoolean), 'enable_caching'],
    [
        'gradeCalculation',
        /* #__PURE__ */ codecOptional(codecString),
        'grade_calculation',
    ],
    [
        'resultsAlwaysVisible',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(codecBoolean)),
        'results_always_visible',
    ],
    [
        'preferTeacherRevision',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(codecBoolean)),
        'prefer_teacher_revision',
    ],
    [
        'fixtures',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ codecArray(FixtureLike)),
    ],
    [
        'overwriteDuplicateFixtures',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'overwrite_duplicate_fixtures',
    ],
]));
export class JsonPatchAutoTest extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return JsonPatchAutoTestParser.decode(input).map(res => new JsonPatchAutoTest(res));
    }
    static unsafeDecode(input) {
        return JsonPatchAutoTest.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JsonPatchAutoTestParser.encode(data);
    }
    static schema() {
        return JsonPatchAutoTestParser.schema();
    }
}
